import VisitorsLayer from "./VisitorsLayer";
import VisitorsOriginsLayer from "./VisitorsOriginsLayer";
import VisitorsDestinationLayer from "./VisitorsDestinationLayer";
//import ArcsLayer from "./ArcsLayer";
import ZoomOutLayer from "./ZoomOutLayer";
import ZoomOutIntermediateLayer from "./ZoomOutIntermediateLayer";
import IsolinesLayer from "./IsolinesLayer";
import MarkerLayer from "./MarkerLayer";
import VisitorsToPointLayer from "./VisitorsToPointLayer";
// [hygen] Import layers

export const getLayers = () => {
  return [
    ZoomOutLayer(),
    ZoomOutIntermediateLayer(),
    VisitorsLayer(),
    VisitorsOriginsLayer(),
    VisitorsDestinationLayer(),
    VisitorsToPointLayer(),
    IsolinesLayer(),
    MarkerLayer(),

    //ArcsLayer(),

    // [hygen] Add layer
  ];
};
